import React from 'react';

const Audio = ({ audioSrc, audioRef, dispatch }) => {
  return (
    <audio
      src={audioSrc}
      ref={audioRef}
      onLoadedMetadata={e => {
        //console.log('data loaded');
        //console.log(audioRef.current.duration);
        dispatch({
          type: 'SET_DURATION',
          length: e.currentTarget.duration
        });
      }}
      onLoadedData={e => {
       
        dispatch({
          type: 'DATA_LOADED',
          time: e.currentTarget.currentTime
        })
      }}
      onTimeUpdate={e =>
        dispatch({
          type: 'SET_CURRENT_TIME',
          time: e.currentTarget.currentTime
        })
      }
      onSeeking={e => {
        //console.log('seeking');
      }}
    />
  );
};

export default Audio;
